import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

function positiveIntegerValidator(val) {
	if (_.isEmpty(val)) {
		return
	}

	if (val != parseInt(val) || parseInt(val) < 0) {
		return i18n.get('common.error.nonNegativeInteger.tooltip')
	}
}

export default positiveIntegerValidator

positiveIntegerValidator.__filename__ = 'components/validators/positive-integer-validator.js'
